import { SUBSCRIPTION_ALREADY_IN_USE } from 'aa/vue/constants/shared';
import { ButtonState } from 'models/ButtonConfig';
import { TAB } from 'aa/vue/FormConfig';

export default {
    namespaced: true,
    state: {
        hasValidStoredPaymentMethod: false, // If user wants to use a different method in purchase flow we set this to false
        editingStoredPaymentMethod: false, // Only true in switch plan flow or for ex-subscribers
        paymentMethod: TAB.cc, // based on active tab
        formValidated: false, // only used for cc form
        ccTransactionProcessing: false, // set to the event object when user clicks submit button for cc so that PaymentCreditCardForm knows to submit
        transactionProcessing: false,
        paymentMethodUpdateProcessing: false,
        transactionComplete: null,
        paymentMethodUpdateComplete: null,
        coolingRightsWaived: false, // set to true when checkbox is checked
        formErrorCode: null, // set to error string when error is returned from the submit method
        recurlyFormToken: null, // set to token when form is submitted
        payPalToken: null,
        preSelectedCCgateway: null,
        paypalGateway: null,
        // submitButtonState: ButtonState.Disabled, // manages the state of the submit button
        // showSaveCancelButtons: false, // set to true when user is editing payment method in swith plan flow
        // saveButtonState: ButtonState.Disabled, // manages the state of the save button
    },
    mutations: {
        setHasValidStoredPaymentMethod(state, value) {
            state.hasValidStoredPaymentMethod = value;
        },
        setEditingStoredPaymentMethod(state, value) {
            state.editingStoredPaymentMethod = value;
        },
        setPaymentMethod(state, value) {
            state.paymentMethod = value;
        },
        setFormValidated(state, value) {
            state.formValidated = value;
        },
        setTransactionProcessing(state, value) {
            state.transactionProcessing = value;
        },
        setCCTransactionProcessing(state, value) {
            state.ccTransactionProcessing = value;
        },
        setCoolingRightsWaived(state, value) {
            state.coolingRightsWaived = value;
        },
        setFormErrorCode(state, value) {
            state.formErrorCode = value;
        },
        setPaymentMethodUpdateProcessing(state, value) {
            state.paymentMethodUpdateProcessing = value;
        },
        setTransactionComplete(state, value) {
            state.transactionComplete = value;
        },
        setPaymentMethodUpdateComplete(state, value) {
            state.paymentMethodUpdateComplete = value;
        },
        setRecurlyFormToken(state, value) {
            state.recurlyFormToken = value;
        },
        setPayPalToken(state, value) {
            state.payPalToken = value;
        },
        setPaypalGateway(state, value) {
            state.paypalGateway = value;
        },
        setPreSelectedCCgateway(state, value) {
            state.preSelectedCCgateway = value;
        },
    },
    actions: {
        processPurchaseWithRecurlyToken({ commit }, payload) {},
        processPurchaseWithPaypalToken({ commit }, payload) {},
        processPurchaseWithStoredPaymentMethod({ commit }, payload) {},
        updateStoredPaymentMethodInSwitchPlan({ commit }, payload) {},
        retrieveRecurlyFormToken({ commit }, payload) {},
        retrievePayPalToken({ commit }, payload) {
            state.payPalToken = value;
        },
    },
    getters: {
        getHasValidStoredPaymentMethod(state) {
            return state.hasValidStoredPaymentMethod;
        },
        getEditingStoredPaymentMethod(state) {
            return state.editingStoredPaymentMethod;
        },
        getPaymentMethod(state) {
            return state.paymentMethod;
        },
        getFormValidated(state) {
            return state.formValidated;
        },
        getTransactionProcessing(state) {
            return state.transactionProcessing;
        },
        getCCTransactionProcessing(state) {
            return state.ccTransactionProcessing;
        },
        getCoolingRightsWaived(state) {
            return state.coolingRightsWaived;
        },
        getFormErrorCode(state) {
            return state.formErrorCode;
        },
        getPaymentMethodUpdateProcessing(state) {
            return state.paymentMethodUpdateProcessing;
        },
        getTransactionComplete(state) {
            return state.transactionComplete;
        },
        getPaymentMethodUpdateComplete(state) {
            return state.paymentMethodUpdateComplete;
        },
        getShowSaveCancelButtons(state) {
            return state.hasValidStoredPaymentMethod && state.editingStoredPaymentMethod;
        },
        getSaveButtonState(state) {
            // To-Do for FTC Switch Plan Support with in-page edit payment method
            if (state.paymentMethodUpdateProcessing) {
                return ButtonState.Loading;
            }

            if (
                state.hasValidStoredPaymentMethod &&
                state.editingStoredPaymentMethod &&
                state.formValidated
            ) {
                return ButtonState.Enabled;
            }

            return ButtonState.Disabled;
        },
        getSubmitButtonState(state) {
            if (state.transactionProcessing || state.ccTransactionProcessing) {
                return ButtonState.Loading;
            }

            if (state.formErrorCode === SUBSCRIPTION_ALREADY_IN_USE) {
                return ButtonState.Disabled;
            }

            // if we are editing our stored payment method check if ready to make transaction
            // (CC details filled in / paypal connected)
            if (state.editingStoredPaymentMethod) {
                if (state.formValidated && state.paymentMethod === TAB.cc) {
                    return ButtonState.Enabled;
                }

                if (state.paymentMethod === TAB.payPal && state.payPalToken) {
                    return ButtonState.Enabled;
                }
            }

            if (
                state.hasValidStoredPaymentMethod &&
                !state.editingStoredPaymentMethod &&
                state.coolingRightsWaived
            ) {
                return ButtonState.Enabled;
            }

            if (
                state.paymentMethod === TAB.cc &&
                state.formValidated &&
                state.coolingRightsWaived
            ) {
                return ButtonState.Enabled;
            }

            if (
                state.paymentMethod === TAB.payPal &&
                state.payPalToken?.id &&
                state.coolingRightsWaived
            ) {
                return ButtonState.Enabled;
            }

            return ButtonState.Disabled;
        },
        getPayPalToken(state) {
            return state.payPalToken;
        },
        getRecurlyFormToken(state) {
            return state.recurlyFormToken;
        },
    },
};
